/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import React from "react";
import AuthGate from "./src/components/auth/AuthGate";

export const wrapRootElement = ({ element }) => {
  return <AuthGate>{element}</AuthGate>;
};
